export default "__VITE_ASSET__BWanOQA___"